<template>
  <v-content class="token-view">
    <v-row
      justify="center"
      class="token-view__content fill height"
    >
      <transition name="fade">
        <v-col
          cols="12"
          md="5"
          lg="4"
          xl="3"
          class="pa-0"
        >
          <v-row justify="center">
            <StLogo />
          </v-row>

          <v-form
            ref="form"
            v-model="isValid"
            class="token-view__form elevation-1 pa-6 mt-12"
            lazy-validation
            @submit.prevent="enter"
          >
            <StInputComponent
              id="token"
              v-model="token"
              dark
              component="v-text-field"
              prepend-icon="mdi-key"
              name="token"
              :rules="tokenRules"
              :label="$t('views.TokenView.label')"
              type="password"
              :trim="true"
              required
            />

            <v-row
              justify="end"
              class="no-gutters"
            >
              <v-btn
                color="primary"
                class="token-view__button mx-0 my-2"
                type="submit"
                rounded
                large
              >
                {{ $t('views.TokenView.buttonLabel') }}
              </v-btn>
            </v-row>
          </v-form>
        </v-col>
      </transition>
    </v-row>
  </v-content>
</template>

<script>
import StInputComponent from '@stilingue/st-input-component';
import StLogo from '@stilingue/st-logo';
import { notEmpty } from '@stilingue/st-form-rules-utils';
import { mapActions, mapGetters } from 'vuex';
import { GUEST_VALUE } from '@/plugins/appcues';
import { USER_TYPE } from '@/utils/constants';
import { insertRolloutMetadata, Flags } from '@/plugins/rollout';
import { splitStringOnSeparator } from '@/utils/formatter';

export default {
  name: 'TokenView',
  components: {
    StInputComponent,
    StLogo,
  },
  data() {
    return {
      isValid: false,
      token: '',
      tokenRules: [
        notEmpty(),
      ],
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'unsharableCards',
    ]),
    ...mapGetters('featureFlag', [
      'getValue',
    ]),
  },
  async created() {
    const { params, query } = this.$route;

    await insertRolloutMetadata({
      account_id: params.accountId,
      universe_id: params.universeId,
      dashboard_id: query.dashboard,
      user_email: 'guest@stilingue.com.br',
      user_name: USER_TYPE.GUEST,
      user_id: GUEST_VALUE,
      user_group: 'GUEST',
    });

    this.accessPublicDashboard();
  },
  methods: {
    ...mapActions('dashboard', [
      'getDashboards',
    ]),
    async enter() {
      if (!this.token) {
        this.$noty.error(this.$t('views.TokenView.errorMessage'));
        return;
      }

      const { params, query } = this.$route;
      const dashboards = await this.getDashboards({
        universeId: params.universeId,
        token: this.token,
      });

      if (!dashboards?.length) {
        this.$noty.error(this.$t('views.TokenView.errorMessage'));
        this.token = '';
        return;
      }

      insertRolloutMetadata({
        account_id: params.accountId,
        universe_id: params.universeId,
        dashboard_id: query.dashboard,
        user_email: 'guest@stilingue.com.br',
        user_name: USER_TYPE.GUEST,
        user_id: GUEST_VALUE,
        user_group: 'GUEST',
      });

      this.$router.push({
        path: 'dashboard',
        query,
        params,
      });
    },
    async accessPublicDashboard() {
      const publicDashboardInfo = await this.getValue(Flags.publicDashboardInfo);
      const dashboardTokenId = splitStringOnSeparator(publicDashboardInfo, '|')[0] || '';

      if (dashboardTokenId) {
        const { params, query } = this.$route;

        const dashboards = await this.getDashboards({
          universeId: params.universeId,
          token: dashboardTokenId,
        });
        const isAValidToken = Boolean(dashboards.length);

        if (isAValidToken) {
          this.$router.push({
            path: 'dashboard',
            query,
            params,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .token-view {
    background-color: var(--gray-050);

    &__content {
      padding-top: 15vh;
      width: 100%;
      margin: 0 auto 0 auto;
    }

    &__form {
      background-color: var(--gray-100);
    }

    &__button {
      min-width: 125px !important;
    }
  }
</style>
